import { z } from 'zod';

export const WDOrgLinkSchema = z.object({
  name: z.string(),
  url: z.string().url(),
  icon_url: z.string().nullable()
});

type WDOrgLink = z.infer<typeof WDOrgLinkSchema>;

export default WDOrgLink;
